export default "__VITE_ASSET__GhQSdDFj__"